interface Props {
  label?: string
}

/**
 * Centered loading spinner with optional caption. Identical visual on both
 * the QR landing and profile-access pages.
 */
export default function Spinner({ label }: Props) {
  return (
    <div className="spinner-wrap">
      <div className="spinner" />
      {label && <p className="spinner-wrap-text">{label}</p>}
    </div>
  )
}
